module.exports = __webpack_public_path__ + "assets/img/5_1409_big.fafcc766.jpg";